module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa quận huyện",
      "breadcrumbs": [{
        title: 'Quản lý quận huyện',
        route: {
          name: 'district'
        }
      }]
    }
  }), _vm._v(" "), (_vm.localDistrict.id) ? _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createCityForm",
    attrs: {
      "model": _vm.localDistrict,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitCity('createCityForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn tỉnh thành",
      "prop": "city_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn tỉnh thành"
    },
    model: {
      value: (_vm.localDistrict.city_id),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "city_id", $$v)
      },
      expression: "localDistrict.city_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn tỉnh thành",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mã bưu chính ",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mã bưu chính"
    },
    model: {
      value: (_vm.localDistrict.code),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "code", $$v)
      },
      expression: "localDistrict.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localDistrict.name),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "name", $$v)
      },
      expression: "localDistrict.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên viết tắt",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên viết tắt"
    },
    model: {
      value: (_vm.localDistrict.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "short_name", $$v)
      },
      expression: "localDistrict.short_name"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.listCarriers), function(carrier, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      key: _vm.localDistrict[carrier.key],
      attrs: {
        "label": carrier.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": carrier.name
      },
      model: {
        value: (_vm.localDistrict[carrier.key]),
        callback: function($$v) {
          _vm.$set(_vm.localDistrict, carrier.key, $$v)
        },
        expression: "localDistrict[carrier.key]"
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Các loại tên",
      "prop": "map_name"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "reserve-keyword": false,
      "placeholder": "Chọn các loại tên cho quận huyện",
      "no-data-text": "Không có dữ liệu"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.mapNames),
      callback: function($$v) {
        _vm.mapNames = $$v
      },
      expression: "mapNames"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loại quận huyện đi",
      "prop": "kind_from"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Loại quận huyện đi"
    },
    model: {
      value: (_vm.localDistrict.kind_from),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "kind_from", $$v)
      },
      expression: "localDistrict.kind_from"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Loại quận huyện đi",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.districtKind), function(kind, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": kind,
        "value": index
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loại quận huyện đến",
      "prop": "kind_to"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Loại quận huyện đến"
    },
    model: {
      value: (_vm.localDistrict.kind_to),
      callback: function($$v) {
        _vm.$set(_vm.localDistrict, "kind_to", $$v)
      },
      expression: "localDistrict.kind_to"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Loại quận huyện đến",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.districtKind), function(kind, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": kind,
        "value": index
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("Hãng vận chuyển")])], 1), _vm._v(" "), _vm._l((_vm.carriers), function(carrier, index) {
    return (Object.keys(_vm.dataCarriers).length) ? _c('el-row', {
      key: carrier.id,
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20,
        "offset": 2
      }
    }, [(_vm.dataCarriers[carrier.short_name]) ? _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', [_c('el-checkbox', {
      on: {
        "change": function($event) {
          return _vm.pushCarrier(carrier)
        }
      },
      model: {
        value: (_vm.defaultCarriers[carrier.short_name]),
        callback: function($$v) {
          _vm.$set(_vm.defaultCarriers, carrier.short_name, $$v)
        },
        expression: "defaultCarriers[carrier.short_name]"
      }
    }, [_vm._v(_vm._s(carrier.name))])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-form-item', [_c('el-select', {
      staticClass: "width-100",
      attrs: {
        "disabled": !_vm.defaultCarriers[carrier.short_name],
        "filterable": "",
        "placeholder": "Loại quận huyện đi"
      },
      model: {
        value: (_vm.dataCarriers[carrier.short_name].kind_from),
        callback: function($$v) {
          _vm.$set(_vm.dataCarriers[carrier.short_name], "kind_from", $$v)
        },
        expression: "dataCarriers[carrier.short_name].kind_from"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Loại quận huyện đi",
        "value": 0
      }
    }), _vm._v(" "), _vm._l((_vm.districtKind), function(kind, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": kind,
          "value": index
        }
      })
    })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-form-item', [_c('el-select', {
      staticClass: "width-100",
      attrs: {
        "disabled": !_vm.defaultCarriers[carrier.short_name],
        "filterable": "",
        "placeholder": "Loại quận huyện đến"
      },
      model: {
        value: (_vm.dataCarriers[carrier.short_name].kind_to),
        callback: function($$v) {
          _vm.$set(_vm.dataCarriers[carrier.short_name], "kind_to", $$v)
        },
        expression: "dataCarriers[carrier.short_name].kind_to"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Loại quận huyện đến",
        "value": 0
      }
    }), _vm._v(" "), _vm._l((_vm.districtKind), function(kind, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": kind,
          "value": index
        }
      })
    })], 2)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5ae294f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/district/EditDistrict.vue
// module id = 711
// module chunks = 1